import { MapPin, Package, PhoneCall, Truck } from "lucide-react";

export const steps = [
  {
    icon: Package,
    title: "Product Range",
    desc: "Wide variety for animal health needs.",
  },
  {
    icon: Truck,
    title: "Fast Delivery",
    desc: "Timely supply with quality assurance maintained.",
  },
  {
    icon: MapPin,
    title: "Prime Location",
    desc: "Strategically located for faster dispatches.",
  },
  {
    icon: PhoneCall,
    title: "Easy Support",
    desc: "Quick help for queries and orders.",
  },
];
